import React from "react";
import { Dialog, Flex, Text } from '@fluentui/react-northstar'
import PropTypes from "prop-types";
import Constants from "../../../constants/text-constants";
import { observer } from "mobx-react-lite";

const DeleteLocationDialog = observer((props) => {
    const { onCancelDeleteLocation, onConfirmDelete, locationDescription, loading, errorText } = props;

    const onConfirm = () => {
        onConfirmDelete()
    }

    const onCancel = () => {
        onCancelDeleteLocation();
    }

    return (
        <Dialog
            data-testid="deleteLocationDialog"
            className="maxWidthDialog"
            confirmButton={{
                disabled: loading,
                loading: loading,
                content: Constants.DELETE
            }}
            cancelButton={Constants.CANCEL}
            header={Constants.DELETE_LOCATION}
            content={Constants.ARE_YOU_SURE_DELETE_LOC_PREFIX + " " + locationDescription + "?"}
            open={true}
            onCancel={onCancel}
            onConfirm={onConfirm}
            footer={{
                children: (Component, dialogProps) => {
                    const { styles, ...rest } = dialogProps
                    return (
                        <Flex styles={styles}>
                            <Text data-testid="deleteLocationDialogErrorText" error content={errorText} />
                            <Flex.Item push>
                                <Component {...rest} />
                            </Flex.Item>
                        </Flex>
                    )
                },
            }}
        />
    );
});

DeleteLocationDialog.propTypes = {
    onCancelDeleteLocation: PropTypes.func,
    onConfirmDelete: PropTypes.func,
    locationDescription: PropTypes.string,
    loading: PropTypes.bool,
    errorText: PropTypes.string,
};

DeleteLocationDialog.defaultProps = {
    locationDescription: "",
    errorText: "",
    loading: false,
};

export default DeleteLocationDialog;